<script>
  import { createEventDispatcher, onMount } from 'svelte';
  import { performSearch } from '../services/searchService';
  import { isLoadingResults, isLoadingAnswer, currentSearchThreadId, resultsVisible, user, history } from '../stores/stores';
  import { v4 as uuidv4 } from 'uuid';  
  
  import { toast } from '@zerodevx/svelte-toast'
  

  export let placeholder = "Type your follow-up question here...";
  export let searchType = 'basic';

  let query = '';
  let searchInput;
  const dispatch = createEventDispatcher();


  onMount(() => {
    searchInput.focus();
  });

  async function handleSearch() {
    if (query.trim() !== '') {
      isLoadingResults.set(true);
      isLoadingAnswer.set(true);
      const userId = $user ? $user.id : null;
      console.log(`Performing ${searchType} search for query: "${query}"`); // Console log for search type
      try {
        const { fullAnswer, searchThreadId, rankedResults } = await performSearch(query, userId, searchType);
        
        const newThreadId = searchThreadId || uuidv4();
        
        history.update(h => {
          const existingThreadIndex = h.findIndex(thread => thread.ThreadId === newThreadId);
          const newQuery = {
            query,
            results: rankedResults,
            answer: fullAnswer,
            timestamp: new Date().toISOString(),
            searchType // Include search type in the history
          };
          
          if (existingThreadIndex !== -1) {
            const updatedThread = {
              ...h[existingThreadIndex],
              Queries: [...(h[existingThreadIndex].Queries || []), newQuery]
            };
            return [
              updatedThread,
              ...h.slice(0, existingThreadIndex),
              ...h.slice(existingThreadIndex + 1)
            ];
          } else {
            return [{
              ThreadId: newThreadId,
              Queries: [newQuery]
            }, ...h];
          }
        });

        currentSearchThreadId.set(newThreadId);
        resultsVisible.set(false);
        dispatch('search', { query, fullAnswer, searchThreadId: newThreadId, rankedResults, searchType });
      } catch (error) {
        

        if (error.response) {
          if (error.response.status === 429) {
            console.error(error.response.data.error);
            toast.push(error.response.data.error);
          }
          else {console.error("Error in handleSearch:", error);}
        }
        else {
          console.error("Error in handleSearch:", error);
          toast.push("An unexpected error occurred during the search.");
        }
        
      } finally {
        isLoadingResults.set(false);
        isLoadingAnswer.set(false);
      }
      query = '';
    }
  }
</script>

<style>
  .search-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 10px 0;
  }

  .search-bar {
    position: relative;
    display: flex;
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
  }

  input[type="text"] {
    width: 100%;
    padding: 10px;
    padding-right: 40px;
    font-size: 16px;
    border: 1px solid #003476;
    background-color: #ffffff;
    color: #333333;
    border-radius: 4px;
  }

  .search-icon {
    position: absolute;
    right: 10px;
    /* Adjusted to position slightly higher than center */
    top: 40%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #003476;
    font-size: 28px;
    cursor: pointer;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    overflow: hidden;
    margin: 0
  }

  .search-icon:hover {
    color: #002357;
  }

  .arrow {
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>

<div class="search-container">
  <div class="search-bar">
    <input
      id="searchInput"
      type="text"
      bind:value={query}
      bind:this={searchInput}
      {placeholder}
      on:keydown={(e) => e.key === 'Enter' && handleSearch()}
    />
    <button class="search-icon" on:click={handleSearch} aria-label="Search">
      <span class="arrow">→</span>
    </button>
  </div>
  

</div>